import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface StoreSlice {
  selectedStoreId: string;
  setSelectedStoreId: (id: string) => void;
}

export const useStoreSlice = create<StoreSlice>()(
  persist(
    (set) => ({
      selectedStoreId: 'widforss',
      setSelectedStoreId: (id) => set({ selectedStoreId: id }),
    }),
    { name: 'feedforge-selected-store' },
  ),
);
